import React from "react";
import { t } from "ttag";
import { useConfirmation } from '@coolremote/shared';
import { useStoreActions } from "../../models/RootStore";
import useStyles from "./LogOut.style";

export default function LogOut() {
  const doLogout = useStoreActions((a) => a.doLogout);
  const classes = useStyles();
  const confirm = useConfirmation();

  const handleClickOpen = async () => {
    const ok = await confirm({
      title: t`Log Out`,
      bodyMessage: t`Are you sure you want to log-out?`,
      confirmText: t`Yes`,
      cancelText: t`No`,
    });
    if (ok) {
      doLogout();
    }
  };

  return (
    <>
      <div className={classes.dropDownItem} onClick={handleClickOpen}>{t`Log Out`}</div>
    </>
  );
}
